const press = [
	{
		title: 'Violence at Sea: How Terrorists, Insurgents, and Other Extremists Exploit the Maritime Domain',
		publisher: 'Stable Seas, One Earth Future.',
		year: '2020.',
		author: 'Authored with Christopher Faulkner (University of Central Florida), Curtis Bell, Meghan Curran, Tyler Lycan, and Jay Benson (all Stable Seas)',
		category: 'major_regional_thematic_report',
		link: 'https://www.stableseas.org/post/violence-at-sea-how-terrorists-insurgents-and-other-extremists-exploit-the-maritime-domain',
		imageSrc: 'waterHut.jpg',
		previewText: "While the challenges of securing the maritime domain are well understood in both academic and policy circles, developing robust and effective capabilities to quell maritime threats remains an intricate challenge."
	},
	{
		title: 'Stable Seas: Bay of Bengal.',
		publisher: 'Stable Seas, One Earth Future.',
		year: '2020.',
		author: 'Authored with Jay Benson, Curtis Bell, Lydelle Joubert, Maisie Pigeon, Asyura Salleh (all stable seas), Gayathri Iyer, (Observer Research Foundation), M J Rahman (World Fish), and M A Wahab (World Fish)',
		category: 'major_regional_thematic_report',
		link: 'https://www.stableseas.org/post/stable-seas-bay-of-bengal#:~:text:Stable%20Seas%3A%20Bay%20of%20Bengal%20examines%20maritime%20security%20and%20governance,enforcement%20capacity%2C%20and%20international%20cooperation.',
		imageSrc: 'waterSun.jpg',
		previewText: "Examines maritime security and governance in the Bay of Bengal across nine issue areas including the blue economy, coastal welfare, rule of law, piracy and armed robbery, illicit trades, maritime mixed migration, fisheries, maritime enforcement capacity, and international cooperation."
	},
	{
		title: 'Black Sea Synergy: A Holistic Approach to Maritime Security.',
		publisher: 'Europeum institute of European Policy.',
		year: '2022.',
		author: 'Author.',
		category: 'policy_brief_publication',
		link: 'https://www.europeum.org/en/articles/detail/4692/policy-brief-black-sea-synergy-adopting-a-holistic-approach-to-maritime-security',
		imageSrc: 'waterMountains.jpg',
		previewText: 'Provides an overview of the current situation in the region, possible threats, and ways to prevent them. '
	},
	{
		title: 'Addressing Maritime Security in Southeast Asia',
		publisher: 'Stable Seas, One Earth Future.',
		year: '2021.',
		author: 'Author.',
		category: 'policy_brief_publication',
		link: 'https://www.stableseas.org/post/addressing-maritime-security-in-southeast-asia',
		imageSrc: 'waterTree.jpg',
		previewText: 'Policy brief thats maps and measures threats to maritime security across Southeast Asia, as well as the efforts to counter them. '
	},

	{
		title: 'BARMM Blue Economy: Policy Proposals',
		publisher: 'Stable Seas, One Earth future.',
		year: '2020.',
		author: 'Author.',
		category: 'policy_brief_publication',
		link: 'https://www.stableseas.org/post/the-blue-economy-in-the-bangsamoro-autonomous-region-in-muslim-mindanao',
		imageSrc: 'waterRocks.jpg',
		previewText: 'Examines how improvements to the Blue Economy of the Bangsamoro Autonomous  Region can be made.'
	},
	{
		title: 'Challenges and Solutions for Maritime Security in the Indian Ocean.',
		publisher: 'Stable Seas.',
		year: '2020',
		author: 'Author.',
		category: 'policy_brief_publication',
		link: 'https://www.stableseas.org/post/challenges-and-solutions-for-maritime-security-in-the-indian-ocean',
		imageSrc: 'waterSunset.jpg',
		previewText: 'Examines maritime security and governance in the Indian Ocean region across nine issue areas.'
	},
	{
		title: 'Opioid Smuggling in the Black Sea.',
		publisher: 'Eurasian Review.',
		year: '2022.',
		author: 'Author',
		category: 'open_editorial',
	},

	{
		title: 'The Hungarian Ukrainian Schism.',
		publisher: ' Real Clear Defense.',
		year: '2022.',
		author: 'Author.',
		category: 'open_editorial',
	},
	{
		title: 'Moving Forward: Japan’s Maritime Policy Trajectory in the Philippines.',
		publisher: 'Analyzing War.',
		year: '2021.',
		author: 'Author.',
		category: 'open_editorial',
	},
	{
		title: 'Deconstructing Abu Sayyaf’s Resilience to Counter-Insurgency Operations',
		publisher: 'The Diplomat,',
		year: '2021',
		category: 'open_editorial',
		author: 'Author.',
	},
	{
		title: 'Countering Maritime Drug Trafficking in Bangladesh’s Coastal Waters.',
		publisher: 'Stable Seas, One earth future.',
		year: '2020.',
		author: 'Author.',
		category: 'open_editorial',
	},
	{
		title: 'A South Pacific Island-Led Approach to Regional Maritime Security.',
		publisher: 'Center for International Maritime Security.',
		year: '2020.',
		author: 'Author',
		category: 'open_editorial',
	},
	{
		title: 'Thailand’s Deep South Insurgencies: Exploiting the Maritime Domain.',
		publisher: 'The Diplomat.',
		year: '2020.',
		author: 'Author',
		category: 'open_editorial',
	},
	{
		title: 'Using Geospatial Data to Improve Maritime Domain Awareness in the Sulu and Celebes Seas.',
		publisher: 'Center for International Maritime Security.',
		year: '2020.',
		author: 'Author.',
		category: 'open_editorial',
	},
	{
		title: 'A Collaborative Approach to Improving Maritime Security in the Bay of Bengal.',
		publisher: 'Stable Seas, One Earth Future.',
		year: '2020.',
		author: 'Author.',
		category: 'open_editorial',
	},
	{
		title: 'Tamil Sea Tigers: Exploiting the Maritime Domain.',
		publisher: 'Stable Sea, One Earth Future.',
		author: 'Author.',
		category: 'open_editorial',
	},
	{
		title: 'Engaging With Local Stakeholders to Improve Maritime Security and Governance.',
		publisher: 'Modern Diplomacy.',
		year: '2020.',
		author: 'Author.',
		category: 'open_editorial',
	},
	{
		title: 'Japan’s Contributions to Maritime Stability in the Bay of Bengal.',
		publisher: 'East Asia Forum.',
		year: '2020.',
		author: 'Author.',
		category: 'open_editorial',
	},
	{
		title: 'How a Myanmar Coast Guard Will Contribute to Coastal Stability.',
		publisher: 'The Diplomat.',
		year: '2020.',
		author: 'Author.',
		category: 'open_editorial',
	},
	{
		title: 'Community Engagement: Improving Maritime Domain Awareness in the Bay of Bengal.',
		publisher: 'Stable Seas, One Earth Future.',
		year: '2020',
		author: 'Author',
		category: 'open_editorial',
	},
	{
		title: 'The Future of Philippine Maritime Enforcement.',
		publisher: 'ASEAN Post. 2019.',
		author: 'Author.',
		category: 'open_editorial',
	},
	{
		title: 'Deterrence and Inclusivity in the South China Sea.',
		publisher: 'Global Politics Magazine. 2019.',
		author: 'Author.',
		category: 'open_editorial',
	},
	{
		title: 'An Advisory Capacity: The Wider Ramifications of Security Force Assistance Brigades in Afghanistan.',
		publisher: 'Small Wars Journal. 2019.',
		author: 'Author.',
		category: 'open_editorial',
	},
];

export default press;
